import { FillRateMetricChart } from '../../../renderers/fill-rate-metric-chart/fill-rate-metric-chart.component';
import { ChartRendererProps } from '../../../types/chart-renderer-props';
import { SPOT_FILL_RATE_METRIC_CHART_DEFINITION } from './spot-fill-rate-metric-chart.definition';
import { SPOT_FILL_RATE_METRIC_CHART_MOCK_DATA } from './spot-fill-rate-metric-chart.mock';

export const SpotFillRateMetricChart = (props: ChartRendererProps) => <FillRateMetricChart {...props} />;

SpotFillRateMetricChart.definition = SPOT_FILL_RATE_METRIC_CHART_DEFINITION;
SpotFillRateMetricChart.mockData = SPOT_FILL_RATE_METRIC_CHART_MOCK_DATA;
